export enum PlanApiUrls {
    GetPlans ='/api/Plan/GetPlans',
    CreatePlan ='/api/Plan/CreatePlan',
    CreatePlanFromAms ='/api/Plan/CreatePlanFromAMS',
    EditPlan ='/api/Plan/EditPlan',
    AssignLocationsGroupsToPlan ='/api/Plan/AssignLocationsGroupsToPlan',
    CreatePlanJobs ='/api/Plan/CreatePlanJobs',
    EditPlanJobs ='/api/Plan/EditPlanJobs',
    GenerateRoutes ='/api/Plan/GenerateRoutes',
    CreatePlanRevision ='/api/Plan/CreatePlanRevision',
    CreatePlanWithLocations ='/api/Plan/CreatePlanWithLocations',
    DeletePlan ='/api/Plan/DeleteCompletePlan',
    ClonePlan ='/api/Plan/ClonePlan',
    OptimizePlan ='/api/Plan/OptimizePlan',
    CalculatePlanETA ='/api/Plan/CalculatePlanETA',
    CalculateHDPlanETA ='/api/Plan/CalculateCompleteHDPlan',
    ImportPlan = '/api/Plan/ImportPlan',
    ImportPlanCSV = '/api/Plan/CreatePlanUsingCsvFile',
    PlanCSV = '/api/Plan/CreatePlanUsingCsvFile',
    ExportPlanCSV = '/api/Plan/ExportPlan',
    ExportPlanToCsv = '/api/Plan/ExportPlanToCsv',
    GetAllPlanJobs ='/api/Plan/GetAllPlanJobs',
    CreateEditPlanSchedule = '/api/SchedulerConfiguration/CreateEditPlanSchedule',
    GetPlanSchedule ='/api/PlanContainer/GetPlanSchedule?planId=',
    BindLocationWithMultiplePlanJob = '/api/Plan/BindLocationWithMultiplePlanJob',
    GetPlanIntimationForService = '/api/Plan/GetPlanIntimationForService',
    UnCommitPlan = '/api/Plan/UnCommitPlan',
    RemovePlanScheduler = '/api/SchedulerConfiguration/RemovePlanSchedule',
    GetPlanById = '/api/Plan/GetPlanById',
    InjectPlanLocations= '/api/Plan/InjectPlanLocations',
    ValidateJobsCSV='/api/Plan/ValidateJLCsvFile',
    UpdatePlanByValidatedDataOfCSV='/api/Plan/UpdatePlanByValidatedDataOfCSV',
    GenerateHDRoutes ='/api/Plan/GenerateHDRoutes',
  }
